"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridType = void 0;
/**
 * Grid type enumeration
 */
var GridType;
(function (GridType) {
    /**
     * Grid Zone Designator
     */
    GridType[GridType["GZD"] = 0] = "GZD";
    /**
     * Hundred Kilometer
     */
    GridType[GridType["HUNDRED_KILOMETER"] = 100000] = "HUNDRED_KILOMETER";
    /**
     * Ten Kilometer
     */
    GridType[GridType["TEN_KILOMETER"] = 10000] = "TEN_KILOMETER";
    /**
     * Kilometer
     */
    GridType[GridType["KILOMETER"] = 1000] = "KILOMETER";
    /**
     * Hundred Meter
     */
    GridType[GridType["HUNDRED_METER"] = 100] = "HUNDRED_METER";
    /**
     * Ten Meter
     */
    GridType[GridType["TEN_METER"] = 10] = "TEN_METER";
    /**
     * Meter
     */
    GridType[GridType["METER"] = 1] = "METER";
})(GridType = exports.GridType || (exports.GridType = {}));
//# sourceMappingURL=GridType.js.map